(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-annual-savings-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sb-savings-widget')) {
    customElements.define(
      'sb-savings-widget',
      class SbSavingsWidget extends HTMLElement {
        connectedCallback() {
          this.renderCountdown();

          this.addEventListener('click', (event) => {
            const toggle = event.target.closest('.sb-annual-savings__toggle');
            if (!toggle) return;
            this.toggleDetails(toggle);
          });
        }

        renderCountdown() {
          const numEl = this.querySelector('[data-countdown-num]');
          const targetDate = this.dataset.targetDate;
          if (!numEl || !targetDate) return;

          const target = new Date(`${targetDate}T00:00:00`);
          const now = new Date();
          const msPerDay = 24 * 60 * 60 * 1000;
          const daysLeft = Math.max(0, Math.ceil((target - now) / msPerDay));

          numEl.textContent = daysLeft;
        }

        toggleDetails(toggle) {
          const panel = this.querySelector('#' + toggle.getAttribute('aria-controls'));
          if (!panel) return;
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          panel.hidden = expanded;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-comparison"] && !Shopify.designMode) return;
  try {
    
  const initializeComparison = (root) => {
    if (root.dataset.comparisonReady === 'true') return;

    const scroller = root.querySelector('[data-comp-scroll]');
    const navigation = root.querySelector('[data-comp-nav]');
    const previousButton = root.querySelector('[data-comp-prev]');
    const nextButton = root.querySelector('[data-comp-next]');

    if (!scroller || !navigation || !previousButton || !nextButton) return;

    root.dataset.comparisonReady = 'true';

    const updateNavigation = () => {
      const maximumScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const hasOverflow = maximumScroll > 2;
      const atStart = scroller.scrollLeft <= 2;
      const atEnd = scroller.scrollLeft >= maximumScroll - 2;

      navigation.hidden = !hasOverflow;
      previousButton.disabled = atStart;
      nextButton.disabled = atEnd;
      root.classList.toggle('sb-comp--at-start', atStart);
      root.classList.toggle('sb-comp--at-end', atEnd);
      root.classList.toggle('sb-comp--scrollable', hasOverflow);
    };

    const scrollOneProduct = (direction) => {
      const productColumn = root.querySelector('.sb-comp__col-head');
      if (!productColumn) return;

      scroller.scrollBy({
        left: productColumn.getBoundingClientRect().width * direction,
        behavior: 'smooth'
      });
    };

    previousButton.addEventListener('click', () => scrollOneProduct(-1));
    nextButton.addEventListener('click', () => scrollOneProduct(1));
    scroller.addEventListener('scroll', updateNavigation, { passive: true });

    const resizeObserver = new ResizeObserver(updateNavigation);
    resizeObserver.observe(scroller);
    updateNavigation();
  };

  const initializeComparisons = (scope = document) => {
    scope.querySelectorAll('[data-comparison]').forEach(initializeComparison);
  };

  initializeComparisons();
  document.addEventListener('shopify:section:load', (event) => initializeComparisons(event.target));

  } catch(e) { console.error(e); }
})();
})();
